import { MessageCircle } from "lucide-react";
import { WHATSAPP_URL } from "@/data/siteData";

export default function FloatingWhatsApp() {
  return <a className="floating-whatsapp" href={WHATSAPP_URL} target="_blank" rel="noreferrer" aria-label="Open WhatsApp concierge" data-testid="floating-whatsapp-widget"><span className="floating-whatsapp__pulse" /><MessageCircle size={20} /><span className="floating-whatsapp__label">WhatsApp concierge</span></a>;
}
